const removeTrailingSlash = (url: string) => {
    return url.endsWith('/') && url.length > 1 ? url.slice(0, -1) : url;
};

export const normalizeUrl = (url: string) => {
    const trimmed = url.trim();
    const withoutTrailingSlash = removeTrailingSlash(trimmed);
    return withoutTrailingSlash.toLowerCase();
};

export const areUrlsEqual = (url: string, urlToCompare: string) => {
    return normalizeUrl(url) === normalizeUrl(urlToCompare);
};
